// <<<<<<< HEAD
// <<<<<<< HEAD
// import React, { useState, useRef } from 'react';
// import { Route, Routes, Link } from 'react-router-dom';
// import './index.css';
// import NeuralNetworkBackground from './NeuralNetworkBackground';
// import WhatWeDo from './WhatWeDo';
// import Predict from './Predict';
// import CoverLetter from './CoverLetter';
// import GenerateResume from './GenerateResume';
// import MarketTrends from './MarketTrends';

// function App() {
//   const [showResumeSection, setShowResumeSection] = useState(false);
//   const [showPredictSection, setShowPredictSection] = useState(false);
//   const resumeSectionRef = useRef(null);
//   const predictSectionRef = useRef(null);

//   const handleResumeClick = () => {
//     setShowResumeSection(true);
//     setShowPredictSection(false);
//     if (resumeSectionRef.current) {
//       resumeSectionRef.current.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   const handlePredictClick = () => {
//     setShowPredictSection(true);
//     setShowResumeSection(false);
//     if (predictSectionRef.current) {
//       predictSectionRef.current.scrollIntoView({ behavior: 'smooth' });
// =======


// import React, { useState, useRef } from 'react';
// import { Route, Routes, Link } from 'react-router-dom';
// import './index.css';
// import NeuralNetworkBackground from './NeuralNetworkBackground';
// import WhatWeDo from './WhatWeDo';
// import Predict from './Predict';
// import CoverLetter from './CoverLetter';
// import GenerateResume from './GenerateResume';
// import MarketTrends from './MarketTrends';
// import StudyAssistant from './StudyAssistant'; // Add this import

// function App() {
//   const [showResumeSection, setShowResumeSection] = useState(false);
//   const [showPredictSection, setShowPredictSection] = useState(false);
//   const [showStudySection, setShowStudySection] = useState(false); // Add this state
//   const resumeSectionRef = useRef(null);
//   const predictSectionRef = useRef(null);
//   const studySectionRef = useRef(null); // Add this ref

// <<<<<<< HEAD
//   const renderContent = () => {
//     switch (view) {
//       case 'predict':
//         return (
//           <Paper elevation={3} sx={{ p: 4, mb: 4, bgcolor: '#f9fafb' }}>
//             <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#1976d2' }}>
//               Predict Resume Selection
//             </Typography>
//             <Predict />
//             <Button variant="outlined" onClick={() => setView('landing')} sx={{ mt: 2, fontWeight: 500 }}>
//               Back to Home
//             </Button>
//           </Paper>
//         );
//       case 'coverLetter':
//         return (
//           <Paper elevation={3} sx={{ p: 4, mb: 4, bgcolor: '#f9fafb' }}>
//             <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#1976d2' }}>
//               Generate Cover Letter
//             </Typography>
//             <CoverLetter />
//             <Button variant="outlined" onClick={() => setView('landing')} sx={{ mt: 2, fontWeight: 500 }}>
//               Back to Home
//             </Button>
//           </Paper>
//         );
//       case 'generateResume':
//         return (
//           <Paper elevation={3} sx={{ p: 4, bgcolor: '#f9fafb' }}>
//             <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, color: '#1976d2' }}>
//               Generate ATS-Friendly Resume
//             </Typography>
//             <GenerateResume />
//             <Button variant="outlined" onClick={() => setView('landing')} sx={{ mt: 2, fontWeight: 500 }}>
//               Back to Home
//             </Button>
//           </Paper>
//         );
//       default:
//         return (
//           <Box className="landing-container">
//             <Box
//               className="landing-content"
//               sx={{
//                 bgcolor: 'rgba(0, 0, 0, 0.6)',
//                 p: { xs: 3, sm: 4 },
//                 borderRadius: 2,
//                 textAlign: 'center',
//                 color: 'white',
//                 boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
//               }}
//             >
//               <Typography
//                 variant="h3"
//                 gutterBottom
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: { xs: '2rem', sm: '3rem' },
//                   textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
//                 }}
//               >
//                 Resume Screening App
//               </Typography>
//               <Typography
//                 variant="h5"
//                 gutterBottom
//                 sx={{
//                   fontWeight: 500,
//                   fontSize: { xs: '1.5rem', sm: '2rem' },
//                   mb: 3,
//                 }}
//               >
//                 Streamline Your Job Application Process
//               </Typography>
//               <Typography
//                 variant="body1"
//                 sx={{
//                   mb: 4,
//                   maxWidth: '600px',
//                   mx: 'auto',
//                   fontSize: { xs: '1rem', sm: '1.2rem' },
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Our app helps you succeed in job applications by predicting resume selection chances, generating professional cover letters, and creating ATS-friendly resumes tailored to your skills and experience.
//               </Typography>
//               <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, maxWidth: '600px', mx: 'auto' }}>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={() => setView('predict')}
//                   sx={{ py: 1.5, fontSize: '1.1rem', flex: 1 }}
//                 >
//                   Predict Resume Selection
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={() => setView('coverLetter')}
//                   sx={{ py: 1.5, fontSize: '1.1rem', flex: 1 }}
//                 >
//                   Generate Cover Letter
//                 </Button>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={() => setView('generateResume')}
//                   sx={{ py: 1.5, fontSize: '1.1rem', flex: 1 }}
//                 >
//                   Generate ATS-Friendly Resume
//                 </Button>
//               </Box>
//             </Box>
//           </Box>
//         );
// >>>>>>> e948deee (Added new folder)
// =======
//   const handleResumeClick = () => {
//     setShowResumeSection(true);
//     setShowPredictSection(false);
//     setShowStudySection(false); // Hide other sections
//     if (resumeSectionRef.current) {
//       resumeSectionRef.current.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   const handlePredictClick = () => {
//     setShowPredictSection(true);
//     setShowResumeSection(false);
//     setShowStudySection(false); // Hide other sections
//     if (predictSectionRef.current) {
//       predictSectionRef.current.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   // Add this new handler
//   const handleStudyClick = () => {
//     setShowStudySection(true);
//     setShowResumeSection(false);
//     setShowPredictSection(false);
//     if (studySectionRef.current) {
//       studySectionRef.current.scrollIntoView({ behavior: 'smooth' });
// >>>>>>> 83315ad6 (Updated feature study assistant market trend.js on click cover letter generation)
//     }
//   };

//   return (
//     <div>
// <<<<<<< HEAD
// <<<<<<< HEAD
// =======
// >>>>>>> 83315ad6 (Updated feature study assistant market trend.js on click cover letter generation)
//       <NeuralNetworkBackground />
//       <nav className="navbar">
//         <Link to="/">
//           <button>Home</button>
//         </Link>
//         <Link to="/what-we-do">
//           <button>What We Do</button>
//         </Link>
//         <Link to="/about-us">
//           <button>About Us</button>
//         </Link>
//       </nav>
//       <Routes>
//         <Route
//           path="/"
//           element={
//             <div className="landing-container">
//               <div className="landing-content">
//                 <h1>Welcome to Resume Screening App</h1>
//                 <h2>Your Career, Optimized with AI</h2>
//                 <p>
//                   Our AI-powered platform helps you craft the perfect resume, generate professional cover letters, and stay ahead with market trends.
//                 </p>
//                 <div className="button-container">
//                   <button onClick={handleResumeClick}>Resume Assistance</button>
//                   <button onClick={handlePredictClick}>Analyse resume</button>
// <<<<<<< HEAD
// =======
//                   <button onClick={handleStudyClick}>Study Assistant</button> {/* Add this button */}
// >>>>>>> 83315ad6 (Updated feature study assistant market trend.js on click cover letter generation)
//                   <Link to="/market-trends">
//                     <button>Market Trends</button>
//                   </Link>
//                 </div>
//               </div>
//               {showResumeSection && (
//                 <div className="resume-section" ref={resumeSectionRef}>
//                   <h2>Resume Assistance</h2>
//                   <p>
//                     Upload your resume or use our tools to generate a professional resume tailored to your career goals.
//                   </p>
//                   <div className="section-content">
//                     <h3>Generate Resume</h3>
//                     <GenerateResume />
//                     <h3>Create Cover Letter</h3>
//                     <CoverLetter />
//                   </div>
//                 </div>
//               )}
//               {showPredictSection && (
//                 <div className="predict-section" ref={predictSectionRef}>
//                   <h2>Analyze resume</h2>
//                   <p>Analyze your resume to predict your chances of success and get personalized feedback.</p>
//                   <div className="section-content">
//                     <Predict />
//                   </div>
//                 </div>
//               )}
// <<<<<<< HEAD
// =======
//               {/* Add this new section */}
//               {showStudySection && (
//                 <div className="study-section" ref={studySectionRef}>
//                   <h2>Study Assistant</h2>
//                   <p>Get personalized study plans, practice questions, and learning resources to advance your career.</p>
//                   <div className="section-content">
//                     <StudyAssistant />
//                   </div>
//                 </div>
//               )}
// >>>>>>> 83315ad6 (Updated feature study assistant market trend.js on click cover letter generation)
//             </div>
//           }
//         />
//         <Route path="/what-we-do" element={<WhatWeDo />} />
//         <Route
//           path="/about-us"
//           element={
//             <div className="landing-container">
//               <div className="landing-content">
//                 <h1>About Us</h1>
//                 <p>Learn more about our mission to empower job seekers with AI-driven tools.</p>
//               </div>
//             </div>
//           }
//         />
//         <Route
//           path="/market-trends"
//           element={
//             <div className="landing-container">
//               <MarketTrends />
//             </div>
//           }
//         />
//       </Routes>
// <<<<<<< HEAD
// =======
//       <AppBar position="static" sx={{ bgcolor: '#1976d2', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}>
//         <Toolbar>
//           <Typography
//             variant="h6"
//             component="div"
//             sx={{ flexGrow: 1, textAlign: 'center', fontWeight: 600, letterSpacing: 1 }}
//           >
//             Resume Screening App
//           </Typography>
//         </Toolbar>
//       </AppBar>
//       <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
//         {renderContent()}
//       </Container>
//       <footer style={{ backgroundColor: '#1976d2', color: 'white', textAlign: 'center', padding: '15px', marginTop: '30px' }}>
//         <Typography variant="body2">&copy; 2025 Resume Screening App. All rights reserved.</Typography>
//       </footer>
// >>>>>>> e948deee (Added new folder)
// =======
// >>>>>>> 83315ad6 (Updated feature study assistant market trend.js on click cover letter generation)
//     </div>
//   );
// }

// export default App;

import React, { useState, useRef } from 'react';
import { Route, Routes, Link } from 'react-router-dom';
import './index.css';
import NeuralNetworkBackground from './NeuralNetworkBackground';
import WhatWeDo from './WhatWeDo';
import Predict from './Predict';
import CoverLetter from './CoverLetter';
import GenerateResume from './GenerateResume';
import MarketTrends from './MarketTrends';
import StudyAssistant from './StudyAssistant';

function App() {
  const [showResumeSection, setShowResumeSection] = useState(false);
  const [showPredictSection, setShowPredictSection] = useState(false);
  const [showStudySection, setShowStudySection] = useState(false);
  const resumeSectionRef = useRef(null);
  const predictSectionRef = useRef(null);
  const studySectionRef = useRef(null);

  const handleResumeClick = () => {
    setShowResumeSection(true);
    setShowPredictSection(false);
    setShowStudySection(false);
    if (resumeSectionRef.current) {
      resumeSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePredictClick = () => {
    setShowPredictSection(true);
    setShowResumeSection(false);
    setShowStudySection(false);
    if (predictSectionRef.current) {
      predictSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleStudyClick = () => {
    setShowStudySection(true);
    setShowResumeSection(false);
    setShowPredictSection(false);
    if (studySectionRef.current) {
      studySectionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div>
      <NeuralNetworkBackground />
      <nav className="navbar">
        <Link to="/">
          <button>Home</button>
        </Link>
        <Link to="/what-we-do">
          <button>What We Do</button>
        </Link>
        <Link to="/about-us">
          <button>About Us</button>
        </Link>
      </nav>
      <Routes>
        <Route
          path="/"
          element={
            <div className="landing-container">
              <div className="landing-content">
                <h1>Welcome to Resume Screening App</h1>
                <h2>Your Career, Optimized with AI</h2>
                <p>
                  The core mission of Career Coach AI is to streamline career preparation for students. Specific
objectives include:
• Delivering personalised career guidance based on user profiles and aspirations.
• Enabling the generation of customized resumes and cover letters to match job requirements.
• Calculating selection chances for job applications using predictive analytics.
• Providing up-to-date insights into job market trends and emerging opportunities.
• Offering study assistance, including detailed roadmaps for career paths and curated study
materials.
These goals are achieved through a modular design that incorporates machine learning for accuracy
and React's reactivity for a smooth user experience, ensuring the platform evolves with user
feedback and technological advancements.

                </p>
                <div className="button-container">
                  <button onClick={handleResumeClick}>Resume Assistance</button>
                  <button onClick={handlePredictClick}>Analyse resume</button>
                  <button onClick={handleStudyClick}>Study Assistant</button>
                  <Link to="/market-trends">
                    <button>Market Trends</button>
                  </Link>
                </div>
              </div>
              {showResumeSection && (
                <div className="resume-section" ref={resumeSectionRef}>
                  <h2>Resume Assistance</h2>
                  <p>
                    Upload your resume or use our tools to generate a professional resume tailored to your career goals.
                  </p>
                  <div className="section-content">
                    <h3>Generate Resume</h3>
                    <GenerateResume />
                    <h3>Create Cover Letter</h3>
                    <CoverLetter />
                  </div>
                </div>
              )}
              {showPredictSection && (
                <div className="predict-section" ref={predictSectionRef}>
                  <h2>Analyze resume</h2>
                  <p>Analyze your resume to predict your chances of success and get personalized feedback.</p>
                  <div className="section-content">
                    <Predict />
                  </div>
                </div>
              )}
              {showStudySection && (
                <div className="study-section" ref={studySectionRef}>
                  <h2>Study Assistant</h2>
                  <p>Get personalized study plans, practice questions, and learning resources to advance your career.</p>
                  <div className="section-content">
                    <StudyAssistant />
                  </div>
                </div>
              )}
            </div>
          }
        />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route
          path="/about-us"
          element={
            <div className="landing-container">
              <div className="landing-content">
                <h1>About Us</h1>
                <p>Learn more about our mission to empower job seekers with AI-driven tools.</p>
              </div>
            </div>
          }
        />
        <Route
          path="/market-trends"
          element={
            <div className="landing-container">
              <MarketTrends />
            </div>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
